import React from "react";

import "./index.scss";

const SwitchBtn = ({value, onClick}) => {
  return <div onClick={onClick} className={value ? "switch-btn switch-btn-revert" : "switch-btn switch-btn-action"}>
    <div className="btn-circle"/>
  </div>
};

export default SwitchBtn;
